import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { ScrollProgress } from "@/components/ScrollProgress";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { AboutDoctor } from "@/components/AboutDoctor";
import { Services } from "@/components/Services";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { BookingCalculator } from "@/components/BookingCalculator";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp, StickyMobileCTA } from "@/components/FloatingButtons";

function App() {
  const [presetTreatment, setPresetTreatment] = useState(null);

  return (
    <div className="App min-h-screen bg-white text-slate-900">
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <AboutDoctor />
        <Services onBookTreatment={(id) => setPresetTreatment(id)} />
        <WhyChooseUs />
        <BookingCalculator
          presetTreatment={presetTreatment}
          onConsumePreset={() => setPresetTreatment(null)}
        />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <StickyMobileCTA />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
